(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusReviewControllers')
        .controller('RecomUpdateStatusAssessActionPlansToReviewListController', Controller);

    Controller.$inject = ['$state', 'actionPlansByAssessor'];

    function Controller($state, actionPlansByAssessor) {

        if ($state.is('recomActionPlanUpdateStatusReview.actionPlans')) {

            // TODO
            // Add no actions plans redirect here

            var actionPlanToReview = _.find(actionPlansByAssessor, { ActionPlanAssessment: { IsReviewed: false } });
            var actionPlanId = actionPlansByAssessor[0].ActionPlan.ActionPlanID;

            if (!_.isUndefined(actionPlanToReview)) {
                actionPlanId = actionPlanToReview.ActionPlan.ActionPlanID
            }

            $state.go('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriterias',
                  { ActionPlanID: actionPlanId },
                  { location: 'replace' });
        }
    }
})();